/**
 * The language toggle, in the top bar on every screen.
 *
 * In the bar rather than buried in settings because the person who needs it is
 * often not the person who set the school up — a clerk sitting down at a shared
 * machine should be able to change it in one click, and change it back.
 */

import { cn } from "@/shared/lib/cn";

import { LANGUAGES, useLanguage } from ".";

export function LanguageSwitcher() {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div
      className="flex items-center rounded-lg border border-[var(--border-subtle)] p-0.5"
      role="group"
      aria-label={t("Language")}
    >
      {LANGUAGES.map((entry) => (
        <button
          key={entry.code}
          type="button"
          onClick={() => setLanguage(entry.code)}
          aria-pressed={language === entry.code}
          title={entry.label}
          className={cn(
            "rounded-md px-2.5 py-1 text-xs font-medium transition-colors",
            language === entry.code
              ? "bg-[var(--brand)] text-white"
              : "text-muted hover:bg-[var(--surface-hover)]",
          )}
        >
          {entry.short}
        </button>
      ))}
    </div>
  );
}
